/**
 * @desc 盘点单发起审核
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inventoryMaster.initiateAudit.Params, options?: any) {
  return updateResponse(
    http(URL + `/inventoryMaster/initiateAudit`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
